import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import bisac from "astrid-config/src/bisac.json";

import Flex from "../../../components/Flex/Flex";
import themeColors from "../../ui/constants/themeColors";

export default function useArticleBisacOptions({ suggestions } = {}) {
	const { t } = useTranslation();

	return useMemo(() => {
		return Object.entries(bisac)
			.sort((a, b) => {
				return suggestions?.includes(b[0]) - suggestions?.includes(a[0]);
			})
			.map(([key, text]) => {
				const suggested = suggestions?.includes(key);

				return {
					key,
					value: key,
					text: `${key} ${text}`,
					content: (
						<>
							<Flex
								gap={10}
								justifyContent="flex-start"
								alignItems="flex-start"
								style={{ lineHeight: 1.3 }}
							>
								<span className="monospace">{key}</span>

								<span style={{ color: themeColors.GREY }}>
									{suggested && (
										<>
											<span style={{ color: themeColors.BLUE }}>
												{t("suggestion", "Suggestion")}
											</span>
											<br />
										</>
									)}

									{text}
								</span>
							</Flex>
						</>
					),
				};
			});
	}, [suggestions, t]);
}
